const faqSection = document.querySelector("div.shopify-section.section-wrapper:has(span.faq-section) div.group-block-content");
const details = faqSection.querySelectorAll("accordion-custom details");

details.forEach((targetDetail) => {
  targetDetail.addEventListener("toggle", () => {
    
    // If opened, close all others
    if (targetDetail.open) {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.open = false;
        }
      });
    }

  });
});

const menuItemsContainer = document.querySelector("header header-drawer.header__drawer--mobile");
const menuItems = menuItemsContainer.querySelectorAll('.menu-drawer__menu-item');

menuItems.forEach((item) => {
  item.addEventListener("click", () => {
    
    if (menuItemsContainer.querySelector('details').open) {
      menuItemsContainer.querySelector('.menu-drawer__close-button').click();
    }

  });
});

// window.addEventListener("load", () => {
// const formPopup = document.querySelector('shopify-forms-embed');

//   console.log(formPopup);
// if (formPopup?.shadowRoot) {
//   //const formPopup = form.shadowRoot.querySelector('section[data-sizing="form-wrapper"]');

//   if (popup) {
//     const style = document.createElement('style');
//     style.textContent = `
//       :host {
//         --col-size: 410px !important;
//       }
//     `;
//     formPopup.shadowRoot.appendChild(style);
//   }
// }
// });

(function () {
  function updateHistogram() {
    const jsonEl = document.querySelector(
      'script.jdgm-all-reviews-widget-v2025-data-json'
    );

    if (!jsonEl) return;

    let data;

    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    document.querySelectorAll('.review_summary .jdgm-widget .jm-histogram-row').forEach(function (row) {
      const ratingEl = row.querySelector('.jm-histogram-row__rating');
      const frequencyEl = row.querySelector('.jm-histogram-row__frequency');

      if (!ratingEl || !frequencyEl) return;

      const rating = Number(ratingEl.textContent.trim());

      const item = data.histogram.find(function (item) {
        return item.rating === rating;
      });

      if (!item) return;

      const newValue = item.percentage + '%';

      if (frequencyEl.textContent.trim() !== newValue) {
        frequencyEl.textContent = newValue;
      }
    });
  }

  const observer = new MutationObserver(function () {
    updateHistogram();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  updateHistogram();
})();